import cs from 'classnames';
import React, { type FC } from 'react';
import { BurgerMenuDesktop, Logo, MiniAccount, Search } from '@/Module/DefaultLayout/Component';
import { useCampaign } from '@/Module/DefaultLayout/Hook';
import { useAppSelector } from '@/Module/Store/Hook';
import DefaultLayoutHeaderMenu from './DefaultLayoutHeaderMenu';
import HeaderDesktopBanner from './HeaderDesktopBanner';
import LoggedInHeaderDesktop from './LoggedInHeaderDesktop';
const DefaultLayoutHeaderDesktop: FC = () => {
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const {
    bannerEnabled
  } = useCampaign();
  return <>
      {bannerEnabled ? <HeaderDesktopBanner /> : null}
      <header className={cs('border-4 z-[101] border-blueFive bg-blueFour py-3 text-white', `${isLoggedIn ? 'sticky' : 'sticky top-0'}`)}>
        <div className="container flex flex-row  items-stretch justify-between gap-2">
          <Logo data-sentry-element="Logo" data-sentry-source-file="DefaultLayoutHeaderDesktop.tsx" />
          <DefaultLayoutHeaderMenu data-sentry-element="DefaultLayoutHeaderMenu" data-sentry-source-file="DefaultLayoutHeaderDesktop.tsx" />
          <div className="flex flex-row items-center gap-3">
            {!isLoggedIn && <MiniAccount />}
            <Search data-sentry-element="Search" data-sentry-source-file="DefaultLayoutHeaderDesktop.tsx" />
            <BurgerMenuDesktop data-sentry-element="BurgerMenuDesktop" data-sentry-source-file="DefaultLayoutHeaderDesktop.tsx" />
          </div>
        </div>
      </header>
      {isLoggedIn && <div className="sticky top-0 z-[99] flex justify-evenly border-4 border-blueFive bg-white p-4 text-white">
          <LoggedInHeaderDesktop />
          <MiniAccount />
        </div>}
    </>;
};
export default React.memo(DefaultLayoutHeaderDesktop);